import React from 'react'
import { ClipboardList } from 'lucide-react'
import { useTranslation } from '../../hooks/use-i18n'

interface Props {
  onClick: () => void
  className?: string
}

const RoomRulesButton: React.FC<Props> = ({ onClick, className = '' }) => {
  const { t } = useTranslation()
  return (
    <button
      type="button"
      onClick={onClick}
      className={`p-2 sm:p-2.5 rounded-xl bg-emerald-500/15 border border-emerald-400/50 text-emerald-400 hover:bg-emerald-500/25 hover:border-emerald-400/70 transition-all shrink-0 shadow-sm ${className}`}
      title={t('roomPage.rules')}
      aria-label={t('roomPage.rules')}
    >
      <ClipboardList size={18} className="w-[18px] h-[18px]" />
    </button>
  )
}

export default RoomRulesButton
